import _ from "lodash";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  uploadEncodedFile,
  deleteBulkRequest,
} from "NetworkCall";
import { INSTANCE_URL, itemCount, BASE_IMAGES_URL } from "Constants";
import LocaleStrings from "Languages";
import { randomstring } from "randomstring-js";

export var PROPOSAL_STEP = "PROPOSAL_STEP";
export var PROPOSAL_FORM_STATUS = "PROPOSAL_FORM_STATUS";
export var PROPOSAL_REVIEWER = "PROPOSAL_REVIEWER";
export var PROPOSAL_REVIEW_CRITERIA = "PROPOSAL_REVIEW_CRITERIA";
export var APPUSER_REVIEWER_LIST = "APPUSER_REVIEWER_LIST";
export var PROPOSAL_FORM_LIST = "PROPOSAL_FORM_LIST";
export var PROPOSAL_REVIEWER_LIST = "PROPOSAL_REVIEWER_LIST";
export var PROPOSAL_RESPONSE_LIST = "PROPOSAL_RESPONSE_LIST";
export var PROPOSAL_LIST = "PROPOSAL_LIST";
export var PROPOSAL_URL_MODAL = "PROPOSAL_URL_MODAL";
export var PROPOSAL_FORM_EDIT_MODAL = "PROPOSAL_FORM_EDIT_MODAL";
export var PROPOSAL_ADD_REVIEWER_MODAL = "PROPOSAL_ADD_REVIEWER_MODAL";
export var CHANGE_REVIEWER_MODAL = "CHANGE_REVIEWER_MODAL";
export var PROPOSAL_REPONSE_MODAL = "PROPOSAL_REPONSE_MODAL";
export var PROPOSAL_RANKING = "PROPOSAL_RANKING";
export var PROPOSAL_TICKET_SEND_MODAL = "PROPOSAL_TICKET_SEND_MODAL";
export var MANAGE_PROPOSAL_MODAL = "MANAGE_PROPOSAL_MODAL";
export var PROPOSAL_EDIT = "PROPOSAL_EDIT";
export var MANAGE_REVIEWER_PWD_MODAL = "MANAGE_REVIEWER_PWD_MODAL";
export var PROPOSAL_CONFIRM_MODAL = "PROPOSAL_CONFIRM_MODAL";
export var PROPOSAL_ALL_USERS = "PROPOSAL_ALL_USERS";
export var PROPOSAL__UNREVIEWED_RESPONSE_LIST =
  "PROPOSAL__UNREVIEWED_RESPONSE_LIST";
export var PROPOSAL_REVIEWED_RESPONSE_LIST = "PROPOSAL_REVIEWED_RESPONSE_LIST";
export var PROPOSAL_SHORTLISTED_RESPONSE_LIST =
  "PROPOSAL_SHORTLISTED_RESPONSE_LIST";
export var PROPOSAL_REJECTED_RESPONSE_LIST = "PROPOSAL_REJECTED_RESPONSE_LIST";
export var SHOW_PROPOSAL_LOADER = "SHOW_PROPOSAL_LOADER";
export var RATINGS_STORE = "RATINGS_STORE";
export var PROPOSAL_ALL_RESPONSE_LIST = "PROPOSAL_ALL_RESPONSE_LIST";
export var UPDATED_PROPOSAL_LOADER = "UPDATED_PROPOSAL_LOADER";
export var FILTER_PROPOSAL = "FILTER_PROPOSAL";
export var SORTBY_FILTER_PROPOSAL = "SORTBY_FILTER_PROPOSAL";

export function fetchProposalStep(step) {
  return { type: PROPOSAL_STEP, payload: step };
}

export function checkProposalFormStatus(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal?related=*&include_count=true&filter=((eventid=${session.eventid}) AND (ispublished=0))&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_FORM_STATUS,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function emptyProposalFormStatus(session) {
  return {
    type: PROPOSAL_FORM_STATUS,
    payload: { data: {}, count: 0 },
  };
}

export function checkProposalReviewer(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_REVIEWER,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function checkProposalReviewCriteria(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/review_criteria`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_REVIEW_CRITERIA,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function addProposal(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal`;
  //console.log('session',session);
  let eventid = session.eventid;
  let createdby = session.userid;
  let updatedby = createdby;
  values = { ...values, eventid, createdby, updatedby };
  let body = { resource: values };

  // debugger;
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchReviewerList(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/reviewer?filter=((eventid=${session.eventid}))&include_count=true&order=createdon%20DESC${offSetQuery}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: APPUSER_REVIEWER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function addReviewer(
  session,
  values,
  reviewerArr,
  update = false,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer`;
  let body = { resource: reviewerArr };

  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal/${values.proposalid}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        if (update) {
          patchRequest(
            updateurl,
            values,
            session,
            dispatch,
            (response1) => {
              callback({ success: 1 });
            },
            (error) => {
              callback({ success: 0, message: error });
            }
          );
        } else {
          callback({ success: 1 });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchProposalForm(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_forms?related=proposal_by_formid&include_count=true&filter=((eventid=${session.eventid}) AND (formtype='proposal'))&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_FORM_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function proposalReviewerList(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/reviewer?related=proposal_reviewer_by_reviewerid&include_count=true&filter=(eventid=${session.eventid})&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_REVIEWER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function searchReviewer(
  session,
  search,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var searchQuery = `(firstname like %${search}%) OR (lastname like %${search}%) OR (email like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/reviewer?related=proposal_reviewer_by_reviewerid&include_count=true&filter=(${filter})&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        //console.log('response :- ', response)
        dispatch({
          type: APPUSER_REVIEWER_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchResponseList(
  session,
  status,
  proposalid = "",
  pageCount = 0,
  countPerPage = 0,
  sortby = "all",
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var filter = encodeURI(`(eventid=${session.eventid}) AND (status=${status})`);
  var callfrom = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC${offSetQuery}`;
  if (proposalid != "") {
    filter = encodeURI(
      `(eventid=${session.eventid}) AND (status=${status}) AND (proposalidfk=${proposalid})`
    );

    callfrom = encodeURI(
      `(eventid=${session.eventid}) AND (proposalidfk=${proposalid})`
    );

    url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC${offSetQuery}`;
  }
  //console.log("sortby", sortby);
  if (sortby == "" || sortby == "reject" || sortby == "resubmit") {
    if (sortby == "") {
      filter = encodeURI(
        `(eventid=${session.eventid}) AND (status=${status}) AND ((markas IS NULL) OR (markas=''))`
      );

      callfrom = encodeURI(
        `(eventid=${session.eventid}) AND ((markas IS NULL) OR (markas=''))`
      );
    } else {
      filter = encodeURI(
        `(eventid=${session.eventid}) AND (status=${status}) AND (markas=${sortby})`
      );

      callfrom = encodeURI(
        `(eventid=${session.eventid}) AND (markas=${sortby})`
      );
    }

    url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC${offSetQuery}`;
  }
  // if(search != ''){
  //   var searchQuery = `(firstname like %${search}%) OR (lastname like %${search}%) OR (email like %${search}%)`;
  //   filter = encodeURI(`(${searchQuery}) AND (status=${status})`)
  //   url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&filter=(${filter})&order=submission_date%20DESC`;
  // }

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_RESPONSE_LIST,
          payload: {
            data: response.resource,
            statuscount: response.statuscount,
            count: response.meta.count,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function searchResponseList(
  session,
  status,
  proposalid = "",
  search,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var itemCount = 20;
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var filter = encodeURI(`(eventid=${session.eventid}) AND (status=${status})`);
  var callfrom = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC${offSetQuery}`;
  if (proposalid != "") {
    filter = encodeURI(
      `(eventid=${session.eventid}) AND (status=${status}) AND (proposalidfk=${proposalid})`
    );
    callfrom = encodeURI(
      `(eventid=${session.eventid}) AND (proposalidfk=${proposalid})`
    );
    url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC${offSetQuery}`;
  }
  if (search != "") {
    var searchQuery = `(firstname like %${search}%) OR (lastname like %${search}%) OR (email like %${search}%)`;
    filter = encodeURI(
      `(${searchQuery}) AND (status=${status}) AND (eventid=${session.eventid})`
    );
    callfrom = encodeURI(`(eventid=${session.eventid}) AND (${searchQuery})`);
    url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?callfrom=${callfrom}&include_count=true&related=*&filter=(${filter})&order=submission_date%20DESC`;
  }

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_RESPONSE_LIST,
          payload: {
            data: response.resource,
            statuscount: response.statuscount,
            count: response.meta.count,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function makeEmptyResponseList(session, response) {
  return (dispatch) => {
    dispatch({
      type: PROPOSAL_RESPONSE_LIST,
      payload: { statuscount: response.statuscount },
    });
  };
}

export function publishProposal(session, values, callback) {
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal/${values.proposalid}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      updateurl,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchProposal(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal?related=*&include_count=true&filter=((eventid=${session.eventid}))&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1, data: response.resource });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function searchProposal(
  session,
  search,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var itemCount = 20;
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${itemCount}&offset=${offset}`;

  var searchQuery = `proposal_name like %${search}%`;
  var filter = encodeURI(`(${searchQuery})AND(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal?related=*&include_count=true&filter=(${filter})&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        //console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_LIST,
          payload: { data: response.resource, count: response.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function addCriteria(session, criteriaArr, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/review_criteria`;
  let body = { resource: criteriaArr };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openProposalUrl(showModal, formnumber = "") {
  return {
    type: PROPOSAL_URL_MODAL,
    payload: { showModal: showModal, formnumber: formnumber },
  };
}

export function openProposalForm(showModal, proposalform = {}) {
  return {
    type: PROPOSAL_FORM_EDIT_MODAL,
    payload: { showModal: showModal, proposalform: proposalform },
  };
}

export function updateProposal(session, values, callback) {
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal/${values.proposalid}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      updateurl,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openAddReviewer(showModal, proposalid = "") {
  return {
    type: PROPOSAL_ADD_REVIEWER_MODAL,
    payload: { showModal: showModal, proposalid: proposalid },
  };
}

export function openChangeReviewer(showModal, response = []) {
  return {
    type: CHANGE_REVIEWER_MODAL,
    payload: { showModal: showModal, response: response },
  };
}

export function changeReviewer(session, values, proposalidfk, callback) {
  var filter = encodeURI(
    `(proposalidfk=${proposalidfk}) AND (reviewerid=${values.reviewerid})`
  );
  var geturl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer?filter=${filter}&include_count=true`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer`;

  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/${values.id}`;
  let data = {};
  data.proposalidfk = proposalidfk;
  data.reviewerid = values.reviewerid;
  data.eventid = session.eventid;
  var body = { resource: [data] };
  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    getRequest(
      geturl,
      session,
      dispatch,
      (feedback) => {
        if (feedback.meta.count > 0) {
          patchRequest(
            updateurl,
            values,
            session,
            dispatch,
            (response) => {
              callback({ success: 1 });
            },
            (error) => {
              callback({ success: 0, message: error });
            }
          );
        } else {
          postRequest(
            url,
            body,
            session,
            dispatch,
            (response1) => {
              patchRequest(
                updateurl,
                values,
                session,
                dispatch,
                (response2) => {
                  callback({ success: 1 });
                },
                (error) => {
                  callback({ success: 0, message: error });
                }
              );
            },
            (error) => {
              callback({ success: 0, message: error });
            }
          );
        }
      },
      (error) => {}
    );
  };
}

export function makeShortlisted(session, values, callback) {
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/${values.id}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      updateurl,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openProposalResponseModal(
  showModal,
  response = [],
  selectedTab = "",
  bgColor = ""
) {
  return {
    type: PROPOSAL_REPONSE_MODAL,
    payload: {
      showModal: showModal,
      response: response,
      selectedTab: selectedTab,
      bgColor: bgColor,
    },
  };
}

export function fetchProposalRanking(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_review?related=*`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL_RANKING,
          payload: { data: response.resource },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function openProposalSendTicketModal(
  showModal,
  response = []
  // handleSelect
) {
  return {
    type: PROPOSAL_TICKET_SEND_MODAL,
    payload: {
      showModal: showModal,
      response: response,
      // handleSelect: handleSelect,
    },
  };
}

export function sendTicket(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/ticketsendmail`;
  var body = {
    ...values,
    eventid: session.eventid,
  };
  //console.log('body : - ', body);

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function manageProposalModal(showModal, proposal = {}) {
  return {
    type: MANAGE_PROPOSAL_MODAL,
    payload: { showModal: showModal, proposal: proposal },
  };
}

export function editProposal(proposal) {
  return { type: PROPOSAL_EDIT, payload: proposal };
}

export function fetchSingleProposal(session, proposalid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal?related=*&include_count=true&filter=((proposalid=${proposalid}))&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response.resource });
      },
      (error) => {}
    );
  };
}

export function deleteReviewer(session, proposalid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer?filter=proposalidfk=${proposalid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchUserList(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateCriteria(session, criteriaArrUpdate, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/review_criteria/`;
  let body = { resource: criteriaArrUpdate, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sendLoginCredentials(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/reviewerCredentials`;
  var body = {
    ...values,
    eventid: session.eventid,
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addReviewRank(
  session,
  criteriaArr,
  responseid,
  comesFrom,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_review`;
  let body = { resource: criteriaArr, eventid: session.eventid };
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/${responseid}`;
  let data = {};
  data.id = responseid;

  data.status = "reviewed";
  if (comesFrom == "shortlisted") {
    data.status = "shortlisted";
  }
  data.markas = null;
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        patchRequest(
          updateurl,
          data,
          session,
          dispatch,
          (response2) => {
            callback({ success: 1 });
          },
          (error) => {
            // callback({ success: 0, message: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function markIncomplete(session, values, callback) {
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/${values.id}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      updateurl,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function proposalResubmissionMail(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/proposal_resubmission`;
  var body = {
    ...values,
  };
  // console.log('body : - ', body);

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function validateEmailForReviewer(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/reviewer?filter=%28email=${values.email}%29AND%28eventid=${session.eventid}%29&fields=*`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        if (data.resource.length > 0) {
          callback({ success: 2, message: LocaleStrings.email_not_available });
        } else {
          callback({ success: 1, message: LocaleStrings.email_available });
        }
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function createReviewer(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/createReviewer`;
  var body = {
    ...values,
    eventid: session.eventid,
  };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({
          success: 1,
          appuserid: response.userresponse.content.resource[0].appuserid,
        });
      },
      (error) => {
        // console.log("add user error", error);
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteProposalReviewer(session, appUser, callback) {
  var delurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_reviewer?filter=reviewerid=${appUser.appuserid}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/reviewer/${appUser.appuserid}`;
  return (dispatch) => {
    deleteRequest(
      delurl,
      session,
      dispatch,
      (response) => {
        deleteRequest(
          url,
          session,
          dispatch,
          (response) => {
            // dispatch(fetchUserList(session));
            callback({ success: 1 });
          },
          (error) => {
            callback({ success: 0, message: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, message: error });
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openReviewerPassowrdModal(showModal, reviewer = {}) {
  return {
    type: MANAGE_REVIEWER_PWD_MODAL,
    payload: { showModal: showModal, reviewer: reviewer },
  };
}

export function _uploadBanner(session, imagedata, filename, callback) {
  var eventid = session.eventid;
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, "");

  var imageJson = {
    resource: [
      {
        name: "images",
        type: "folder",
      },
      {
        name: filename,
        type: "file",
        is_base64: true,
        content: imagedata,
      },
    ],
  };
  return (dispatch) => {
    uploadEncodedFile(
      `${BASE_IMAGES_URL}/eventify/${eventid}/proposals/?check_exist=false`,
      session,
      imageJson,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openProposalConfirmModal(
  showModal,
  response = []
  // handleSelect
) {
  return {
    type: PROPOSAL_CONFIRM_MODAL,
    payload: {
      showModal: showModal,
      response: response,
      // handleSelect: handleSelect,
    },
  };
}

export function createSponsor(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor`;

  var speakerJson = {};
  speakerJson = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      speakerJson,
      session,
      dispatch,
      (data) => {
        var sponsorid = data.resource[0].sponsorid;
        callback({ success: 1, sponsorid: sponsorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  };
}

export function createExhibitor(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors`;

  var speakerJson = {};
  speakerJson = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      speakerJson,
      session,
      dispatch,
      (data) => {
        var exhibitorid = data.resource[0].exhibitorid;
        callback({ success: 1, exhibitorid: exhibitorid });
      },
      (error) => {
        callback({ success: 0, data: error });
      }
    );
  };
}

export function fetchAllAttendies(session, callback) {
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=eventid=${session.eventid}&fields=appuserid,email`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({ type: PROPOSAL_ALL_USERS, payload: response });
        callback({ success: 1 });
      },
      (error) => {
        // callback({ success: 0 });
      }
    );
  };
}

export function deleteProposalRank(session, responseid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_review?filter=responseidfk=${responseid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        // dispatch(fetchUserList(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

// Proposal  Responses New
export function fetchUnreviewedproposal(session, status, callback) {
  var filter = encodeURI(`(eventid=${session.eventid}) AND (status=${status})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('response :- ', response)
        dispatch({
          type: PROPOSAL__UNREVIEWED_RESPONSE_LIST,
          payload: {
            data: response.resource,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
export function fetchReviewedproposal(session, status, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(status=${status})AND((markas !='reject') OR (markas is null))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('reviewedresponse :- ', response)
        dispatch({
          type: PROPOSAL_REVIEWED_RESPONSE_LIST,
          payload: {
            data: response.resource,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
export function fetchShortlistedproposal(session, status, callback) {
  var filter = encodeURI(`(eventid=${session.eventid}) AND (status=${status})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('PROPOSAL_REJECTED_RESPONSE_LIST :- ', response)
        dispatch({
          type: PROPOSAL_SHORTLISTED_RESPONSE_LIST,
          payload: {
            data: response.resource,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
export function fetchRejectedproposal(session, status, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (status=${status}) AND (markas='reject')`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log('PROPOSAL_REJECTED_RESPONSE_LIST :- ', response)
        dispatch({
          type: PROPOSAL_REJECTED_RESPONSE_LIST,
          payload: {
            data: response.resource,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function updateProposalStatus(
  session,
  updateproposalResponseArray,
  callback
) {
  let body = {
    resource: {
      ...updateproposalResponseArray,
    },
  };

  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/`;

  return (dispatch) => {
    patchRequest(
      updateurl,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, data: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function showProposalLoader(showLoader) {
  return {
    type: SHOW_PROPOSAL_LOADER,
    payload: { showLoader: showLoader },
  };
}
export function updatedDragProposal(updated) {
  return {
    type: UPDATED_PROPOSAL_LOADER,
    payload: { updated: updated },
  };
}

export function ratingArrStore(rating) {
  return {
    type: RATINGS_STORE,
    payload: { rating },
  };
}

export function fetchallproposal(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=submission_date%20DESC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=status,display_order`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        let unreviewed = _.filter(response.resource, function (o) {
          return o.status === "unreviewed";
        });
        let reviewed = _.filter(response.resource, function (o) {
          return (
            o.status === "reviewed" && (o.markas === null || o.markas === "")
          );
        });
        let shortlisted = _.filter(response.resource, function (o) {
          return o.status === "shortlisted";
        });
        let rejected = _.filter(response.resource, function (o) {
          return o.status === "reviewed" && o.markas === "reject";
        });
        dispatch({
          type: PROPOSAL_ALL_RESPONSE_LIST,
          payload: {
            data: response.resource,
            unreviewedArr: unreviewed,
            reviewedArr: reviewed,
            shortlistedArr: shortlisted,
            rejectedArr: rejected,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}
export function searchNewResponseList(session, search, sort = "all", callback) {
  let unreviewed = [];
  let reviewed = [];
  let shortlisted = [];
  let rejected = [];
  var sortQuery = `(proposalidfk=${sort})`;
  var searchQuery = `(firstname like %25${search}%25)OR(lastname like %25${search}%25)OR(email like %25${search}%25)`;
  var filter = encodeURI(
    `(eventid=${session.eventid})` +
      (sort != "all" && search != ""
        ? `AND(${sortQuery})AND(${searchQuery})`
        : sort != "all" && search == ""
        ? `AND(${sortQuery})`
        : search != "" && sort == "all"
        ? `AND(${searchQuery})`
        : "")
  );
  // let filter = encodeURI(
  //   `(${searchQuery}) AND (eventid=${session.eventid})`
  // );
  // var filter = encodeURI(
  //   `(eventid=${session.eventid})` +
  //     (sort === "all"
  //       ? `AND(${searchQuery})`
  //       : `AND(proposalidfk=${sort})`)
  //   // +
  //   // (searchQuery === "" ? "" : `AND(${searchQuery})`)
  // );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=status,display_order`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        unreviewed = _.filter(response.resource, function (o) {
          return o.status === "unreviewed";
        });
        reviewed = _.filter(response.resource, function (o) {
          return (
            o.status === "reviewed" && (o.markas === null || o.markas === "")
          );
        });
        shortlisted = _.filter(response.resource, function (o) {
          return o.status === "shortlisted";
        });
        rejected = _.filter(response.resource, function (o) {
          return o.status === "reviewed" && o.markas === "reject";
        });
        dispatch({
          type: PROPOSAL_ALL_RESPONSE_LIST,
          payload: {
            data: response.resource,
            unreviewedArr: unreviewed,
            reviewedArr: reviewed,
            shortlistedArr: shortlisted,
            rejectedArr: rejected,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function sortByRating(session, sort = "all", callback) {
  let unreviewed = [];
  let reviewed = [];
  let shortlisted = [];
  let rejected = [];

  var filter = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response?related=*&include_count=true&filter=(${filter})&order=status,display_order`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        unreviewed = _.filter(response.resource, function (o) {
          return o.status === "unreviewed";
        });
        reviewed = _.filter(response.resource, function (o) {
          return (
            o.status === "reviewed" && (o.markas === null || o.markas === "")
          );
        });
        shortlisted = _.filter(response.resource, function (o) {
          return o.status === "shortlisted";
        });
        rejected = _.filter(response.resource, function (o) {
          return o.status === "reviewed" && o.markas === "reject";
        });
        dispatch({
          type: PROPOSAL_ALL_RESPONSE_LIST,
          payload: {
            data: response.resource,
            unreviewedArr: unreviewed,
            reviewedArr: reviewed,
            shortlistedArr: shortlisted,
            rejectedArr: rejected,
          },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function updateproposalComment(session, values, callback) {
  var updateurl = `${INSTANCE_URL}/api/v2/eventify/_table/proposal_response/${values.id}`;

  values = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      updateurl,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function filterProposalLoader(filter) {
  return {
    type: FILTER_PROPOSAL,
    payload: { filterProposal: filter },
  };
}

export function deletebulkCriteria(session, values, callback) {
  let body = {
    resource: {
      ...values,
    },
  };

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/review_criteria`;
  return (dispatch) => {
    deleteBulkRequest(
      url,
      session,
      body,
      dispatch,
      (response) => {
        // dispatch(fetchUserList(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function sortByfilter(sortfilter) {
  return {
    type: SORTBY_FILTER_PROPOSAL,
    payload: { sortfilter: sortfilter },
  };
}
